import * as React from 'react';

export function LoadingSkeleton() {
  return(
    <div className='empori-2ma-loading-skeleton'>
      <i className='fa-regular fa-circle-dashed fa-spin'></i>
    </div>
  );
}